import { useScaffold } from "@Light/scaffold";
import { useEnrollment } from "./flow/context";
import type { RequirementsPatch } from "./flow/types";

/**
 * Makes a requirements patch for agreeing to the broker terms of service,
 * if one has been configured for the app and hasn't already been agreed to.
 * Accepts an additional custom `condition: boolean` for additional checks.
 */
export function useBrokerTermsAgreement(
  condition = true,
): Pick<RequirementsPatch, "broker_terms_agreement"> | undefined {
  const scaffold = useScaffold();
  const { requirements } = useEnrollment();

  if (!condition) return undefined;

  if (
    !scaffold.page.termsOfServiceUrl ||
    requirements.broker_terms_agreement?.value
  ) {
    return undefined;
  }

  return { broker_terms_agreement: { agreed: true } };
}
